import { Directive, inject, TemplateRef } from "@angular/core";

@Directive({
  selector: "[vlAideContent]",
  standalone: true,
})
export class VlAideContentDirective {
  readonly tpl = inject(TemplateRef);
}
